import { defineComponent } from 'vue';
import JsonEditor from '@/components/json-editor/json-editor.vue';

export default defineComponent({
  name: 'LogsPageDifference',

  components: { JsonEditor },

  props: {
    currentParameter: {
      type: Object as () => Record<string, string>,
      required: true,
    },
  },

});
